import { render, staticRenderFns } from "./CanvasRadar.vue?vue&type=template&id=41b01d1a&"
import script from "./CanvasRadar.vue?vue&type=script&lang=js&"
export * from "./CanvasRadar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports